module.exports = __webpack_public_path__ + "img/iconProjectMaterialPort.4e29da3a.svg";